import {
  type MouseEvent as ReactMouseEvent,
  type FocusEvent as ReactFocusEvent,
} from 'react';

import { calculateMousePositions } from '../../../../core/utils/calculate-mouse-positions.js';
import { useSetState } from '../../../hooks/store/selectors.js';

export const useCategoricalMouseEventHandlers = () => {
  const setState = useSetState();

  const handleMouseEnter = (event: ReactMouseEvent<HTMLDivElement>) => {
    setState((prev) => ({
      ...prev,
      overlays: {
        ...prev.overlays,
        mouseInBounds: true,
        mousePosition: calculateMousePositions(event, event.currentTarget),
        visibleTooltip: true,
      },
    }));
  };

  const handleMouseMove = (event: ReactMouseEvent<HTMLDivElement>) => {
    setState((prev) => ({
      ...prev,
      overlays: {
        ...prev.overlays,
        mouseInBounds: true,
        mousePosition: calculateMousePositions(event, event.currentTarget),
        visibleTooltip: true,
      },
    }));
  };

  const handleMouseLeave = () => {
    setState((prev) => ({
      ...prev,
      overlays: {
        ...prev.overlays,
        mouseInBounds: false,
        mousePosition: undefined,
        visibleTooltip: prev.overlays.pinnedTooltip,
      },
    }));
  };

  const handleFocus = () => {
    setState((prev) => ({
      ...prev,
      overlays: {
        ...prev.overlays,
        mouseInBounds: true,
      },
    }));
  };

  const handleBlur = (event: ReactFocusEvent) => {
    const nextFocusElement = event.relatedTarget;

    if (!event.target?.contains(nextFocusElement)) {
      setState((prev) => ({
        ...prev,
        overlays: {
          ...prev.overlays,
          mouseInBounds: false,
        },
      }));
    }
  };

  return {
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleFocus,
    handleBlur,
  };
};
